import {Component, Input, OnInit} from '@angular/core';
import {AppEventService} from '../../_services/event-broadcaster.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

    constructor(private eventService: AppEventService) {
    }


    @Input()
    app_name: string;
    isLogedIn: boolean;

    ngOnInit() {

        if (localStorage.getItem('currentUser')) {
            this.isLogedIn = true;
        } else {
            this.isLogedIn = false;
        }
        this.eventService.on('login.done').subscribe(data => {
            this.isLogedIn = true;
        });
    }

}
